export const numberFormatter = Intl.NumberFormat(navigator.languages)
export const percentageFormatter = Intl.NumberFormat('en-US', {style: 'percent', maximumFractionDigits: 1})
export const currencyFormatter = Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
